import SleepioBlueSvg from '../../svgs/logos/Sleepio_Blue.svg';
import { SvgProps } from '../../types/svgs';

const SleepioBlue = ({ width, height, alt }: SvgProps) => {
  return <img src={SleepioBlueSvg} width={width} height={height} alt={alt} />;
};

export default SleepioBlue;
